import { useMutation, useQueryClient } from 'react-query';

import { OnboardingFlow } from '../../../../backend/src/user/onboarding-flow';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useCompleteOnboardingFlow = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (flowId: OnboardingFlow) => {
      const response = await fetch(
        `${APIBaseChronos}/api/user/onboarding/complete`,
        getFetchConfig({ method: FetchMethod.POST, data: { flowId } }),
      );

      if (!response.ok) {
        throw new Error('Failed to complete onboarding flow');
      }
    },
    {
      onSuccess: () => queryClient.invalidateQueries([QueryEntity.User]),
    },
  );
};
